import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import './Grid.css'

class Grid extends Component {
  render () {
    let projects = []

    const years = Object.keys(this.props.projects)

    if (this.props.sort === 1) years.sort()
    if (this.props.sort === -1) years.sort((a, b) => b - a)

    years.forEach(year => {
      projects.push(<div key={year} className='box'>{year}</div>)
      this.props.projects[year].forEach(project => {
        projects.push(
          <div key={project.name} className='box'>
            <img src={project.img} alt={project.name} />
            {(project.new) ? <div className='new'><div><span>NEW!</span></div></div> : ''}
            <Link to={`/project/${encodeURI(project.name.replace('?', '%3F'))}`}>
              <div className='boxTitle'><span>{project.name}</span></div>
            </Link>
          </div>
        )
      })
      projects.push(<div key={`${year}c`} className='box'><div className='cross'><img src='img/cross.svg' alt='cross' /></div></div>)
    })
    return (
      <div className='grid'>
        {projects}
      </div>
    )
  }
}

export default Grid



// WEBPACK FOOTER //
// ./src/components/Grid.js